import {CLIENT_PROCESS_ID} from '../../../infrastructure/events/channels';

export async function submitAdoransTranspose({fileName, songNumber, songTitle, toKey}) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 10000);
  try {
    const response = await fetch('/adorans/transpose', {
      method: 'POST', headers: {'Content-Type': 'application/json'}, signal: controller.signal,
      body: JSON.stringify({fileName, songNumber, songTitle, toKey, clientId: CLIENT_PROCESS_ID}),
    });
    if (!response.ok) throw new Error(response.status === 409
      ? 'Piosenka zmieniła się. Odśwież śpiewnik i spróbuj ponownie.'
      : 'Nie udało się zmienić tonacji przez most. Spróbuj ponownie.');
  } catch (error) {
    if (error.name === 'AbortError' || error instanceof TypeError) throw new Error('Brak połączenia z mostem. Spróbuj ponownie.');
    throw error;
  } finally { clearTimeout(timeout); }
}
